import { render, staticRenderFns } from "./PublicationsBySourceBody.vue?vue&type=template&id=6e8d751e&"
import script from "./PublicationsBySourceBody.vue?vue&type=script&lang=js&"
export * from "./PublicationsBySourceBody.vue?vue&type=script&lang=js&"
import style0 from "./PublicationsBySourceBody.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports